<template lang="pug">
  #map(style="position: relative; max-width: 100%; width: 100%; height: 350px")
</template>
<script>
export default {
  props: {
    coords: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    map: {},
    setCoords: [],
    coordinates: []
  }),
  watch: {
    coords(values) {
      this.coordinates = values
      if (values) this.drawPolygon()
    },
    setCoords(values) {
      this.$emit('set-coords', values)
    }
  },
  methods: {
    initMap() {
      window.ymaps.ready(() => {
        this.map = new window.ymaps.Map('map', {
          center: [42.87, 74.59],
          zoom: 12,
          controls: ['rulerControl', 'zoomControl', 'geolocationControl', 'fullscreenControl']
        })
        // console.log('init')
        this.createPolygon()
      })
    },
    createPolygon() {
      let myPolygon = new window.ymaps.Polygon(
        [],
        {},
        {
          // Курсор в режиме добавления новых вершин.
          editorDrawingCursor: 'crosshair',
          // Цвет заливки.
          fillColor: '#000000',
          // Цвет обводки.
          strokeColor: '#0000FF',
          opacity: 0.5,
          // Ширина обводки.
          strokeWidth: 2
        }
      )
      // Добавляем многоугольник на карту.
      this.map.geoObjects.add(myPolygon)

      myPolygon.events.add('geometrychange', e => {
        this.setCoords = myPolygon.geometry.getCoordinates()
      })
      // Включаем режим редактирования с возможностью добавления новых вершин.
      myPolygon.editor.startDrawing()
    },
    drawPolygon() {
      let object = new window.ymaps.GeoObject(
        {
          geometry: {
            type: 'Polygon',
            coordinates: this.coordinates
          }
        },
        {
          fillColor: '#000000',
          strokeColor: '#0000FF',
          opacity: 0.5,
          strokeWidth: 2
        }
      )
      this.map.geoObjects.add(object)
      object.editor.startDrawing()
      object.events.add('geometrychange', e => {
        this.setCoords = object.geometry.getCoordinates()
      })
    },
    destroyMap() {
      this.map.destroy()
      this.coordinates = []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DataBase/Common/MapField.vue